export default __webpack_public_path__ + "static/media/tags.996d8a01.svg";